/*
 * 4-Б4 «Правила записи». По листу — колонка 640: это настройка, которую читают, а не
 * таблица, которую просматривают. Строка правила — текст слева, выбор справа (150 px).
 */

.screen {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  height: 100%;
  min-height: 0;
  padding: var(--space-4);
  overflow: auto;
}

.column {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  max-width: 640px;
  padding: 14px 16px;
  font-size: 12.5px;
  line-height: 1.5;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 12px;
}

.skeletons {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 640px;
}

.scopes {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
}

.rules {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.rule {
  display: grid;
  grid-template-columns: 1fr 150px;
  gap: 12px;
  align-items: center;
  padding-top: 8px;
  border-top: 1px solid var(--grid-line-minor);
}

/*
 * На телефоне выбор встаёт под текст правила во всю ширину. Столбец в 150 px справа
 * оставлял тексту 140 px, и «Записываться не позднее чем за…» ломалось в три строки,
 * а подсказка под ним — в пять.
 */
@media (max-width: 767px) {
  .rule {
    grid-template-columns: minmax(0, 1fr);
    gap: 6px;
  }
}

.ruleName {
  font-weight: var(--font-weight-semibold);
}

.ruleHint {
  font-size: 12px;
  color: var(--text-secondary);
}

.ruleField {
  width: 100%;
  height: 34px;
  padding: 6px 10px;
  font: inherit;
  background: var(--bg-card);
  border: 1px solid var(--border-strong);
  border-radius: 8px;
}

.warning {
  padding: 9px 12px;
  color: var(--status-pending-fg);
  background: var(--status-pending-bg);
  border-radius: 8px;
}

.policy {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-top: 10px;
  border-top: 1px solid var(--grid-line-minor);
}

.policyHead {
  font-weight: var(--font-weight-semibold);
}

.threshold {
  height: 28px;
  padding: 2px 6px;
  font: inherit;
  background: var(--bg-card);
  border: 1px solid var(--border-strong);
  border-radius: 6px;
}

.chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.hint {
  margin: 0;
  font-size: 12px;
  line-height: 1.45;
  color: var(--text-secondary);
}

.error {
  font-size: var(--font-size-sm);
  color: var(--danger);
}

.saved {
  font-size: var(--font-size-sm);
  color: var(--info-fg);
}

.footer {
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
  border-top: 1px solid var(--grid-line-minor);
}
